const DATE_PART_SEPARATOR = "-";
const joinDateString = ({ year = "", month = "", day = "" }) => `${year}${DATE_PART_SEPARATOR}${month}${DATE_PART_SEPARATOR}${day}`;
const splitDateString = ({ date = `${DATE_PART_SEPARATOR}${DATE_PART_SEPARATOR}` }) => {
    const [year = "", month = "", day = ""] = date.split(DATE_PART_SEPARATOR);
    return { year, month, day };
};
const EMPTY_DATE = joinDateString({ day: "", month: "", year: "" });
export { joinDateString, splitDateString, EMPTY_DATE };
